import { Region } from '@moonpig/web-core-types'
import { E_CARD_SIZE_ID } from '../../../constants'
import { useProductsLocaleText } from '../../../locale'
import { Module, ModuleVariantsType } from '../../types'
import {
  MULTI_CARD_CSV_LINK,
  MULTI_CARD_LEARN_MORE_LINK,
} from '@moonpig/web-core-brand/config'

export const createCardSimplifiedModalDesktopConfiguration = ({
  localise,
  storeId,
}: {
  localise: ReturnType<typeof useProductsLocaleText>
  storeId: Region
  isPostcard: boolean
}): Module[] => {
  return [
    {
      __typename: 'ModuleTwoColumn',
      left: [{ __typename: 'ModuleSimplifiedProductImage' }],
      right: [
        {
          __typename: 'ModuleSimplifiedMultiBuyTabs',
          tabs: [
            {
              title: localise('tabs.single_card'),
              label: localise('tabs.single_card_label'),
              modules: [
                { __typename: 'ModuleSimplifiedDispatch' },
                {
                  __typename: 'ModuleSimplifiedVariants',
                  type: ModuleVariantsType.DROPDOWN,
                  displayOptions: {
                    dropdownTitlePosition: 'vertical',
                    titleTypography: 'typeDesktopBodyLabel',
                    titleColor: 'colorTextLabel',
                    color: 'colorTextLabel',
                    showPriceSuffix: true,
                    eCardPlacement: 'last',
                  },
                },
                { __typename: 'ModuleSimplifiedDeliveryInfoText' },
                {
                  __typename: 'ModuleSimplifiedTwoColumnProductHeading',
                  left: [{ __typename: 'ModuleSimplifiedHeading' }],
                  right: [
                    {
                      __typename: 'ModuleFromPrice',
                      displayOptions: {
                        align: 'right',
                        showFrom: false,
                        inline: true,
                        color: 'colorTextHeadline',
                        showSelectedVariantPrice: true,
                      },
                    },
                  ],
                },
                { __typename: 'ModuleButtons' },
              ],
            },
            {
              title: localise('tabs.multi_card'),
              label: localise('tabs.multi_card_label'),
              modules: [
                { __typename: 'ModuleSimplifiedDispatch' },
                { __typename: 'ModuleSimplifiedMultiBuyQuantity' },
                {
                  __typename: 'ModuleSimplifiedVariants',
                  type: ModuleVariantsType.DROPDOWN,
                  unavailableVariants: [E_CARD_SIZE_ID],
                  displayOptions: {
                    dropdownTitlePosition: 'vertical',
                    titleTypography: 'typeDesktopBodyLabel',
                    titleColor: 'colorTextLabel',
                    color: 'colorTextLabel',
                    showPriceSuffix: true,
                  },
                },
                {
                  __typename: 'ModuleSimplifiedDeliveryInfoText',
                  unavailableVariants: [E_CARD_SIZE_ID],
                },
                {
                  __typename: 'ModuleSimplifiedTwoColumnProductHeading',
                  left: [{ __typename: 'ModuleSimplifiedHeading' }],
                  right: [
                    {
                      __typename: 'ModuleFromPrice',
                      displayOptions: {
                        align: 'right',
                        showMultiCardDiscountedPrice: true,
                        showFrom: false,
                        inline: true,
                        color: 'colorTextHeadline',
                        showSelectedVariantPrice: true,
                      },
                    },
                  ],
                },
                { __typename: 'ModuleButtons' },
                { __typename: 'ModulePromotions' },
                {
                  __typename: 'ModuleLink',
                  title: localise(
                    'multicard.how_to_send_to_different_addresses',
                  ),
                  alignment: 'flex-start',
                  href: `/${storeId}${MULTI_CARD_LEARN_MORE_LINK}`,
                  meta: {
                    intent: 'view multi-address info',
                  },
                },
                {
                  __typename: 'ModuleLink',
                  title: localise('multicard.download_csv_template'),
                  alignment: 'flex-start',
                  href: MULTI_CARD_CSV_LINK[storeId],
                  meta: {
                    intent: 'download csv template',
                  },
                },
              ],
            },
          ],
          meta: {
            intent: 'change quantity',
          },
        },
      ],
      ratio: '50/50',
      styles: {
        alignSelfLeft: 'flex-start',
        alignSelfRight: 'stretch',
        minHeight: '0',
        minHeightLeft: '0',
        minHeightRight: '0',
        matchRightHeightToLeft: true,
        widthLeft: '100%',
        widthRight: '100%',
      },
    },
  ]
}
